import styled from 'styled-components';
import { Title as Tit } from '../../styled';
export { Wrapper, PreviousButton } from '../../styled';

export const Title = styled(Tit)`
  margin: 0 0 3.2rem 0;
`;
